export const timeoutFetch = (endpoint: string, options: any, timeout = Number(window.env.REACT_APP_FETCH_TIMEOUT)) =>
  new Promise((resolve, reject) => {
    setTimeout(() => {
      reject(new Error('Timeout Error'));
    }, timeout);
    fetch(endpoint, options).then(async response => {
      if (response.status === 200 || response.status === 201) {
        resolve(response);
      } else {
        reject(new Error(`Endpoint ${endpoint} returned a status of ${response.status}`));
      }
    });
  });
